import React, { useEffect, useState } from 'react'
import { setTimeout } from 'timers';

export const SuccessAlert = ({message,closeAlert}:Props) => {

    const [open,setOpen] = useState<boolean>(true);

    useEffect(()=>{
        setTimeout(()=>{setOpen(false);if(closeAlert) closeAlert()},3000)
    },[setOpen,closeAlert])

    return(
        <>{open &&
        <div className='bg-green-200 p-2 w-40 rounded-md text-lg text-green-600 text-center font-semibold right-3 border border  absolute z-20'>
              <div className='animate-pulse'> {message} </div>
        </div>}
        </>
    )
}

interface Props{
    message:string
    closeAlert?:()=>void
}